import { useQuery } from '@tanstack/react-query';
import { axiosClient } from '../axiosClient';

// The registry strips fields the user lacks access to, so a one-row probe
// reveals the accessible field set. Null means "could not determine" and the
// UI falls back to showing everything.
const useRegistryFields = () => {
  return useQuery({
    queryKey: ['registryFields'],
    queryFn: async (): Promise<string[] | null> => {
      const URL = `${import.meta.env.VITE_API_REGISTRY_URL}?limit=1`;
      const { data } = await axiosClient.get<{
        residences?: Record<string, unknown>[];
      }>(URL);

      const first = data?.residences?.[0];
      return first ? Object.keys(first) : null;
    },
    staleTime: Infinity,
    retry: 1,
  });
};

export default useRegistryFields;
